import React, { Component } from 'react';
import jquery from 'jquery';


class Chord extends Component{
  constructor(props){
    super(props);
    this.state={
      neck:'',
      muted:{
        'e_lo':'o',
        'a':'o',
        'd':'o',
        'g':'o',
        'b':'o',
        'e_hi':'o'
      },
      fret:0
    }
  }
  componentWillMount(){
    const chord = this.props.chord;
    console.log('chorddia: ',chord);
    const muted = this.props.chord.muted;
    const base = this.props.chord.base;
    const fret = this.props.chord.base;
    this.constructChord(chord);
    this.setState({
      chord:chord.chord,
      muted,
      base,
      fret
    });
  }

  constructChord(chord){
    let strings=[];
    let results = [];
    // chord.forEach((val)=>{
    //   results.push(val);
    // });
    // chord = results;
    console.log('constructing chord: ',chord);
    for(let i=0; i<chord.chord.length; i++){
      // var chord= chord.chord;
      const id=i.toString();
      console.log(chord[i]);
      if(chord.chord[i] === false){
      strings.push(
        (
          <div id={i} className='string_section col-xs-2'>
            <div className='touchable_string'>
            </div>
          </div>
        )
      );
      }else{
        strings.push(
          (
            <div id={i} className='string_section col-xs-2'>
              <div className='finger_point'></div>
              <div className='touchable_string'>
              </div>
            </div>
          )
        );
      }
    }
    this.setState({
      neck:strings
    });
  }

  saveChord(e){
    e.preventDefault();

    var chord= {
      muted:this.state.muted,
      base:this.state.fret,
      name:this.refs.name.value,
    };
    if(this.refs.name.value==''){
      this.props.missingName();
      return;
    }
    console.log(chord);
    this.props.saveChord(chord);
    this.refs.name.value='';
    this.setState({
      neck:'',
      muted:{
        'e_lo':'o',
        'a':'o',
        'd':'o',
        'g':'o',
        'b':'o',
        'e_hi':'o'
      },
      fret:0,
      name:'',
      chord:{}
    });
    jquery('.finger_point').remove();
    this.componentWillMount();
  }
  selectFret(e){
    e.preventDefault();
    this.setState({
      fret:e.target.value
    });
  }
  render(){
    return(
      <div>
      <span className='clearfix chord_container'>
        <div className="fret_number">

          <div className="fret_num">{this.state.fret || ''}</div>
        </div>
        <div className="chord_right_static">

        </div>
        <div ref='chord' className="chord row">
          <div className='neck row'>
            <span className='col-xs-2'>E</span>
            <span className='col-xs-2'>A</span>
            <span className='col-xs-2'>D</span>
            <span className='col-xs-2'>G</span>
            <span className='col-xs-2'>B</span>
            <span className='col-xs-2'>E</span>
          </div>
          <div className='muted_strings row'>
            <span id='e_lo' className='col-xs-2'>{this.state.muted['e_lo']}</span>
            <span id='a' className='col-xs-2'>{this.state.muted['a']}</span>
            <span id='d' className='col-xs-2'>{this.state.muted['d']}</span>
            <span id='g' className='col-xs-2'>{this.state.muted['g']}</span>
            <span id='b' className='col-xs-2'>{this.state.muted['b']}</span>
            <span id='e_hi' className='col-xs-2'>{this.state.muted['e_hi']}</span>
          </div>
          { this.state.neck }
        </div>
        <div>
        </div>
      </span>
    </div>
    );
  }
}

export default Chord;



// WEBPACK FOOTER //
// ./src/components/ChordDiagram.js